import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { isValidPassword } from '../../utils/helpers';
import logo from '../../assets/1Risk-Calibri-Final-1097x400.png';
import './ResetPassword.css';

const SUPPORT_URL = 'https://accesso.atlassian.net/servicedesk/customer/portal/1340';

const ResetPasswordForm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const username = searchParams.get('u');
  const apiName = searchParams.get('a');
  const token = searchParams.get('t');

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const formValid = password && passwordConfirm;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== passwordConfirm) {
      setError("Passwords don't match.");
      return;
    }

    if (!isValidPassword(password)) {
      setError('Password does not meet requirements.');
      return;
    }

    setLoading(true);
    try {
      const response = await authAPI.resetPassword(apiName, username, token, password);
      if (response.data) {
        setSuccess(true);
      } else {
        setError('Your password could not be reset. Please contact your administrator.');
      }
    } catch {
      setError('Your password could not be reset. Please contact your administrator.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="reset-container">
        <div className="reset-header-bar">
          <img src={logo} alt="1RISK" className="reset-header-logo" />
          <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="support-link">
            Support
          </a>
        </div>
        <div className="reset-content">
          <div className="reset-card">
            <h1>Password Reset Success</h1>
            <p>Your password has been successfully reset.</p>
            <button className="reset-button" onClick={() => navigate('/login')}>
              Go to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-container">
      <div className="reset-header-bar">
        <img src={logo} alt="1RISK" className="reset-header-logo" />
        <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="support-link">
          Support
        </a>
      </div>

      <div className="reset-content">
        <div className="reset-card">
          <h1>Reset Password</h1>
          <p className="reset-instructions">
            Passwords must be at least eight characters in length, contain at least one number, and
            contain uppercase and lowercase characters.
          </p>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="passwordConfirm">Confirm Password</label>
              <input
                id="passwordConfirm"
                type="password"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="reset-button"
              disabled={!formValid || loading}
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const ResetPassword = () => <ResetPasswordForm />;

export default ResetPassword;
